import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import htmx from "htmx.org";
import TreeNode from "./TreeNode";
import { dispatch } from "../utils/events";

export default class CrossRef extends AlpineComponent {
  constructor(
    public target: string,
    public blockIndex: number | null = null,
    public filter: string | null = null
  ) {
    super();
  }

  init() {
    (window as any)["crossRef"] = this;
  }

  destroy() {}

  onSelect(event: CustomEvent<{ value: string }>) {
    htmx.ajax("get", event.detail.value, {});
  }

  onOpen(event: CustomEvent<TreeNode>) {
    const url = event.detail.openUrl;
    if (!url) return;
    htmx.ajax("get", url, {});
  }

  onClose(event: CustomEvent<TreeNode>) {
    const url = event.detail.closeUrl;
    if (!url) return;
    htmx.ajax("get", url, {});
  }

  onClickCancel() {
    dispatch("resolve-error-completed");
  }
}
